export enum Statuses {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    DELETED = 'DELETED'
} 